export {RRuleOptions, simplify, asFamilywallForm}
export type {RecurrencyFrequency, FamilywallForm}

const
  SU = 'SU',
  MO = 'MO',
  TU = 'TU',
  WE = 'WE',
  TH = 'TH',
  FR = 'FR',
  SA = 'SA',
  DAYOFWEEK = [SU,MO,TU,WE,TH,FR,SA];

//the frequencies familywall handles, a subset of the FREQ values of the rrule spec
type RecurrencyFrequency = 'NONE'|'YEARLY'|'MONTHLY'|'WEEKLY'|'DAILY';

//the recurrency as the familywall forms and the server input beans expect it, ie only strings
type FamilywallForm = {
  recurrency :RecurrencyFrequency,
  recurrencyInterval :string,
  byDay :string,
  byMonthDay :string
};

//modelisation of what is in BYDAY=
class ByDayItem{
  n :number;
  day :string;
  constructor(asstring :string){
    if(asstring.length>2){
      this.n = parseInt(asstring.substring(0,asstring.length-2));
      this.day = asstring.substring(asstring.length-2)
    }else{
      this.day = asstring
    }
  }
  verify(date :Date){
    if(DAYOFWEEK[date.getDay()]!==this.day) return false;
    if(this.n===undefined) return true;
    if(this.n>0){
      var gofirst = date.getDate() -7*(this.n-1);
      if(gofirst<=7 && gofirst>=1){
        return true;
      }
    }else{
      var gonext = new Date(date.getTime());
      gonext.setDate(date.getDate() - 7*(this.n))
      if(gonext.getDate()<=7 && gonext.getDate()>=1){
        return true;
      }
    }
    return false;

  }
  toString(){
    if(this.n!==undefined) return this.n+this.day;
    return this.day;
  }
}
//modelisation of what is in BYMONTHDAY=
class ByMonthItem{
  n :number;
  constructor(asstring :string){
    this.n = parseInt(asstring)
  }
  verify(date :Date){
    if(this.n>0){
      return this.n===date.getDate();
    }else if(this.n<0){
      var gonext = new Date(date.getTime());
      gonext.setDate(date.getDate() - (this.n))
      return gonext.getDate()===1;
    }
  }
  toString(){
    return ""+this.n;
  }
}
//modelisation of a full RRULE (a lot of case are not handled)
class RRuleOptions{
  //declare and not a plain field : the constructor fills them from the rrule string, and toString
  //iterates over the properties actually set, so nothing must be defined upfront
  declare freq? :RecurrencyFrequency;
  declare interval? :number;
  declare byday? :ByDayItem[];
  declare bymonthday? :ByMonthItem[];
  declare wkst? :string;
  declare count? :string;
  declare until? :string;

  constructor(asstring :string){
    asstring.split(';').forEach(item=>{
      var
        pair = item.split('='),
        key = pair[0].toLowerCase(),
        value = pair[1];
      if(value===undefined || value.length===0) return;
      switch(key){
        case 'interval':{
          this.interval=parseInt(value)
          break;
        }
        case 'bymonthday':{
          this.bymonthday= value.split(',').map(asstring=>new ByMonthItem(asstring));
          break;
        }
        case 'byday':{
          this.byday= value.split(',').map(asstring=>new ByDayItem(asstring))
          break;
        }
        case 'freq':
        default:{
          this[key]=value
        }
      }
    })
  }
  verify(date :Date){
    var result = true;
    if(result && this.byday){
      result = (this.byday.find(item=>item.verify(date))!==undefined)
    }
    if(result && this.bymonthday){
      result = (this.bymonthday.find(item=>item.verify(date))!==undefined)
    }
    return result;
  }
  toString(){
    var result :string[] = [];
    Object.entries(this).forEach(pair=>{
      var
        key = pair[0],
        value = pair[1];
      switch(key){
        case 'bymonthday':{
          if(value.length>0){
            result.push(key.toUpperCase()+'='+value.join(','))
          }
          break;
        }
        case 'byday':{
          if(value.length>0){
            result.push(key.toUpperCase()+'='+value.join(','));
          }
          break;
        }
        case 'freq':
        case 'interval':
        default:{
          result.push(key.toUpperCase()+'='+value)
        }
      }
    })
    return result.join(';');
  }
}
/**
 * @param rrule
 * @returns the rrule without useless information like interval=1, BYDAY=MO, BYMONTHDAY=12)
 */
function simplify(rrule :string){
  if(rrule==='NONE' || rrule.length===0) return 'NONE';
  var options = new RRuleOptions(rrule);

  if(options.freq==='MONTHLY'){
    if(options.bymonthday && options.bymonthday.length<2){
      if(options.bymonthday[0].n!==-1){
        delete options.bymonthday;
      }
    }
  }else if(options.freq==='WEEKLY'){
    if(options.byday && options.byday.length<2){
      delete options.byday;
    }
    delete options.bymonthday;
  }else{
    delete options.byday;
    delete options.bymonthday;
  }
  if(options.interval===1){
    delete options.interval;
  }
  delete options.wkst;
  delete options.count;
  delete options.until;

  return options.toString();
}


function asFamilywallForm(rrule :string) :FamilywallForm{
  var
    options = new RRuleOptions(rrule),
    result = {
      recurrency:options.freq ||'NONE',
      recurrencyInterval:""+(options.interval || 1),
      byDay:options.byday?options.byday.join(','):'',
      byMonthDay:options.bymonthday?options.bymonthday.join(','):''
    };
  return result;
}
/* tests
var
  rrule = 'FREQ=MONTHLY;BYMONTHDAY=-1;INTERVAL=2',
  testOptions = new RRuleOptions(rrule)
console.log(rrule,testOptions.toString())
console.log(testOptions.verify(new Date('2023-11-30')))
*/



